<template>
  <div
    :class="{
      'col-span-12 md:col-span-4': true,
      'max-w-[85%] pl-10 pr-40 md:max-w-none md:px-0': true,
    }"
  >
    <h3
      :class="{
        'mb-5 border-b border-www-color-neutral-very-light pb-10px text-8px font-bold uppercase tracking-wider md:text-10px': true,
        'text-www-color-white md:text-www-color-neutral-medium-dark': true,
      }"
    >
      {{ heading }}
    </h3>
    <ul
      :class="{
        'pb-2': true,
      }"
      aria-labelledby="subNavItem-Start"
    >
      <li
        v-for="(link, subMenuIndex) in columnItems"
        :key="subMenuIndex"
        :class="{
          'hover:text-www-color-primary-lighter': true,
        }"
      >
        <GeneralLink
          v-bind="{ ...link, _type: 'generalLink' }"
          text=""
          :class="{
            'text-www-color-white hover:text-www-color-primary-lighter md:text-www-color-neutral-medium-dark': true,
          }"
        >
          <h3
            :class="{
              'mb-5px text-13px font-bold uppercase tracking-wider': true,
            }"
          >
            {{ link.linkTitle }}
          </h3>
          <p
            :class="{
              'mb-5 text-xs font-normal': true,
            }"
          >
            {{ link.linkDescription }}
          </p>
        </GeneralLink>
      </li>
    </ul>
  </div>
</template>
<script setup lang="ts">
import type { ResourceDropdownColumn } from '~/sanity/types';
import GeneralLink from './GeneralLink.vue';

defineProps<ResourceDropdownColumn>();
</script>

<style lang="scss" scoped></style>
